"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageFolders = void 0;
var Types_1 = require("@CommonFrontendBackend/Folders/Types");
var Types_2 = require("Common/AssetLibrary/Types");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var Sidebar_1 = require("Dashboard/Sidebar/Sidebar");
var lodash_1 = require("lodash");
var mobx_react_1 = require("mobx-react");
var FolderHeading_1 = require("Project/ContentSidebar/Folders/FolderHeading");
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var ImageFolders = (0, mobx_react_1.observer)(function (props) {
    var closeFoldersSlot = props.closeFoldersSlot, isUsingImageFolders = props.isUsingImageFolders;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(FolderHeading_1.FolderHeading, { text: "Explore", actions: closeFoldersSlot }),
        react_1.default.createElement("div", null,
            renderSystemFolder(props, Types_1.ImageLibrarySystemFolder.Unsplash),
            renderSystemFolder(props, Types_1.ImageLibrarySystemFolder.RecentlyUsed)),
        isUsingImageFolders && renderAccountFolders(props),
        renderSystemFolder(props, Types_1.ImageLibrarySystemFolder.Uploads)));
});
exports.ImageFolders = ImageFolders;
function renderAccountFolders(_a) {
    var folderViewStore = _a.folderViewStore, onSelectFolder = _a.onSelectFolder;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "space-stack-l" }),
        react_1.default.createElement(FolderHeading_1.FolderHeading, { text: "Account Folders" }),
        react_1.default.createElement("div", { className: "space-stack-l" },
            react_1.default.createElement(kaleidoscope_1.FolderTree, { disableOptions: true, viewStore: folderViewStore.accountFolderViewStore, onSelect: onSelectFolder }))));
}
function renderSystemFolder(_a, folder) {
    var onSelectFolder = _a.onSelectFolder, selectedFolder = _a.selectedFolder;
    return (react_1.default.createElement(Sidebar_1.SystemFolder, { key: folder, collection: folder, onFolderSelect: onSelectFolder, dragDropOnFolder: lodash_1.noop, name: Types_2.FolderNamesMapping[folder], icon: (0, Types_2.FolderIconsMapping)(icons_1.IconSize.Medium)[folder], active: selectedFolder === folder }));
}
